import { Typography, Box, Grid } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Minimize from '@material-ui/icons/Minimize';
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react';


const PatientProfileFertilityPreservation = props => {

    const [expandedPanel, setExpandedPanel] = useState(false);

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    };


    return (
        <Box style={{ paddingTop: "10px" }}>
            <Accordion onChange={handleAccordionChange('panel1')}>
                <AccordionSummary
                    expandIcon={
                        expandedPanel ? <Minimize /> :
                            <AddIcon />
                    }

                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    {!expandedPanel &&
                        <Typography>Cancer Diagnosis & Treatments</Typography>
                    }
                    {expandedPanel &&
                        <>
                            <Box style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", width: "100%" }}>
                                {/* <Box style={{ width: "50%" }}>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        <b>Currently waiting for any cancer diagnosis ?</b>
                                    </Box>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        {props.anyWaitingCancerDiagnosis}
                                    </Box>
                                </Box>
                                <Box display={props.anyWaitingCancerDiagnosis === 'No' ? 'block' : 'none'} style={{ width: "50%" }}></Box>
                                <Box display={props.anyWaitingCancerDiagnosis === 'Yes' && props.pendingCancerDiagnosis !== 'Other' ? 'block' : 'none'} style={{ width: "50%" }}>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        <b>Pending diagnosis</b>
                                    </Box>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        {props.pendingCancerDiagnosis}
                                    </Box>
                                </Box>
                                <Box display={props.pendingCancerDiagnosis === 'Other' ? 'block' : 'none'} style={{ width: "50%" }}>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        <b>Pending diagnosis</b>
                                    </Box>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        {props.otherPendingCancerDiagnosis}
                                    </Box>
                                </Box> */}
                                <Box style={{ width: "100%" }}>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        <b>Have you ever had a cancer diagnosis?</b>
                                    </Box>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        {props.anyCancerDiagnosis}
                                    </Box>
                                </Box>
                                <Box display={props.anyCancerDiagnosis === 'Currently' ? 'block' : 'none'} style={{ width: "50%" }}>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        <b>Current site of cancer</b>
                                    </Box>
                                    <Box style={{ display: "flex", justifyContent: "center" }}>
                                        {props.currentSiteOfCancer}
                                    </Box>
                                </Box>
                            </Box>
                        </>
                    }
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container>
                        {props.cancerDiagnosisAndTreatments?.map((cancer, i) => {
                            return (
                                <>
                                    <>
                                        <Typography style={{ fontWeight: "bolder" }}>
                                            Cancer {i + 1} :
                                        </Typography>
                                    </>
                                    <Box style={{ width: "100%" }}>
                                        <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                            <Box style={{ width: "25%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Primary site of cancer</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {cancer.siteOfCancer}
                                                </Box>
                                            </Box>
                                            <Box display={cancer.siteOfCancer === 'Other' ? 'block' : 'none'} style={{ width: "25%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Other site of cancer</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {cancer.otherSiteOfCancer}
                                                </Box>
                                            </Box>
                                            <Box style={{ width: "25%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Year</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {cancer.year}
                                                </Box>
                                            </Box>
                                            <Box display={cancer.siteOfCancer !== 'Other' ? 'block' : 'none'} style={{ width: "50%" }}></Box>
                                            <Box display={cancer.siteOfCancer === 'Other' ? 'block' : 'none'} style={{ width: "25%" }}></Box>
                                        </Box>
                                        <Box style={{ width: "100%" }}>
                                            <Grid container>
                                                {cancer.treatments?.map((treatment, j) => {
                                                    return (
                                                        <Box style={{ display: "flex", flexWrap: "wrap", width: "100%", marginBottom: "10px" }}>
                                                            <Box style={{ width: "25%" }}>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    <b>Treatment {j + 1}</b>
                                                                </Box>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    {treatment.treatmentType}
                                                                </Box>
                                                            </Box>
                                                            <Box display={treatment.treatmentType === 'Other' ? 'block' : 'none'} style={{ width: "25%" }}>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    <b>Other treatment type</b>
                                                                </Box>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    {treatment.otherTreatmentType}
                                                                </Box>
                                                            </Box>
                                                            <Box display={treatment.treatmentType === 'None' ? 'none' : 'block'} style={{ width: "25%" }}>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    <b>From</b>
                                                                </Box>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    {treatment.treatmentFromYear}
                                                                </Box>
                                                            </Box>
                                                            <Box display={treatment.treatmentType === 'None' ? 'none' : 'block'} style={{ width: "25%" }}>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    <b>To</b>
                                                                </Box>
                                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                                    {treatment.treatmentToYear}
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    )
                                                })}
                                            </Grid>
                                        </Box>
                                    </Box>
                                </>
                            )
                        })}
                    </Grid>

                </AccordionDetails>
            </Accordion>
        </Box>
    )


}
export default PatientProfileFertilityPreservation;